import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { toJS } from 'mobx';
import { Button, colors } from '@insurancemenu/imenu-components-lib';
import { Edit } from '@insurancemenu/imenu-components-lib/dist/icons';
import { adminRights } from '@insurancemenu/imenu-components-lib/dist/utils/accessRights';
import { useRootStore } from 'store/rootStore';
import { AgentOfRecordModalDelegate } from 'store/modules/group/ui-stores/agentOfRecordModalDelegate';
import AgentOfRecordModal from 'components/group-info/AgentOfRecordModal';
import { createStyles } from './styles';

const AgentOfRecord: React.FC = observer(() => {
  const rootStore = useRootStore();
  const {
    groupSidebarStore: {
      group: { id: groupId, agentOfRecord },
    },
  } = rootStore;
  const [modalDelegate] = useState(() => new AgentOfRecordModalDelegate());
  const classes = createStyles();

  const canEdit =
    !rootStore.domainStoreV2.allowTinOnlyGroupCreation &&
    (!rootStore.domainStoreV2.adminOnlyAgentAssignment ||
      (rootStore.domainStoreV2.adminOnlyAgentAssignment && adminRights(rootStore.userStore.userRoles)));

  return (
    <div id="agent-of-record-section">
      <header className={classes.categoryWrapper}>
        <h3 className={classes.categoryName}>{agentOfRecord?.tin ? 'TIN' : 'Agent of Record'}</h3>
        {canEdit ? (
          <Button
            type="text"
            iconSize="1.6rem"
            color="custom"
            customColor={colors.neutral[900]}
            leftIconProp={<Edit />}
            className={classes.editContactInfo}
            onClick={(): void => modalDelegate.open(groupId)}
            id="edit-agent-of-record"
          >
            {' '}
          </Button>
        ) : null}
      </header>
      <div className={classes.contentWrapper}>
        {agentOfRecord && (
          <div className={classes.contactFieldBox} id="agent-of-record-block">
            <div className={classes.aorWrapper}>
              <p className={classes.fieldValue}>{agentOfRecord.tin || agentOfRecord.name || '-'}</p>
              {agentOfRecord.name && !agentOfRecord.id && <div className={classes.tag}>Missing</div>}
            </div>
          </div>
        )}
      </div>
      <AgentOfRecordModal
        show={modalDelegate.modalDelegate.isVisible}
        onClose={(): void => modalDelegate.close()}
        formController={modalDelegate.form}
        agentOptions={modalDelegate.agentOptions.map((option) => toJS(option)).slice()}
      />
    </div>
  );
});

export default AgentOfRecord;
